import { styled, Box } from "@mui/material";

const MessageBot = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isLast",
})<{ isLast: boolean }>(({ theme, isLast }) => ({
  backgroundColor: theme.palette.widgetStyles.botChatBubble.background,
  padding: "10px 13px",
  borderRadius: "5px 5px 5px 0",
  maxWidth: "70%",
  position: "relative",
  whiteSpace: "pre-line",
  wordBreak: "break-word",
  width: "fit-content",
  textAlign: "left",
  color: theme.palette.widgetStyles.botChatBubble.textColor,
  marginRight: "auto",
  marginBottom: "3px",
  fontSize: "1.0625rem",
  marginLeft: isLast ? "53px" : "0",
}));
export default MessageBot;
